const CEC_URL = `${process.env.REACT_APP_SCO_ORIGIN_URL}/cec`
const CEC_REPORT = `${CEC_URL}/report`

const FETCH = `fetch`

const ReportUrls = {
    REPORT_FETCH : `${CEC_REPORT}/${FETCH}`
}

export default ReportUrls